const token = process.env.REACT_APP_FRAME_TOKEN;

const getImageUrl = item => `https://eva.emplas.co.uk/Ajax/GetFrameImage.ashx?jobno=${item.jobNo}&winno=${item.winNo}&token=${token}`;

export { getImageUrl };